<template>
  <main-template>
    <v-container>
      <template v-if="!parametroConsulta">
        <v-row>
          <v-col cols="12">
            <h1>Gestão de Mensalidades</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-if="matriculas"
              :items="matriculas"
              :loading="loadingMatriculas"
              :item-text="
                (matricula) =>
                  `${matricula.aluno.codigo} - ${matricula.aluno.nomecompleto} - ${matricula.turma.descricao}`.toUpperCase()
              "
              :filter="searchQuery"
              label="Qual matrícula você quer selecionar?"
              return-object
              dense
              cache-items
              hide-no-data
              solo
              @change="selecionarMatricula"
            />
          </v-col>
        </v-row>
      </template>

      <v-row v-if="loadingParcelas">
        <v-col cols="12">
          <v-skeleton-loader loading type="table" />
        </v-col>
      </v-row>

      <v-row v-if="!loadingParcelas">
        <v-col cols="12">
          <v-col class="d-flex justify-end">
            <div class="mb-2" v-if="parcelasCriadas === true || !parametroConsulta">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="!matriculaSelecionada.id"
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      () => [openModalNovaParcela(matriculaSelecionada), (showNovaParcela = true)]
                    "
                  >
                    <v-icon small left> fa fa-money </v-icon>
                    Nova Parcela
                  </v-btn>
                </template>
                <span>Nova Parcela</span>
              </v-tooltip>
            </div>
          </v-col>

          <e-snippet-matricula :matricula="matriculaSelecionada" />
          <e-gerar-mensalidades
            v-if="gerandoParcelas"
            :key="matriculaSelecionada.id"
            :matricula="matriculaSelecionada"
            :somente-mensalidades="temApenasParcelaDaPreMatricula"
            @geradas="aoGerarParcelas"
          />

          <v-data-table
            v-else
            :headers="table.headers"
            :items="parcelas ? parcelas : []"
            :items-per-page="15"
            :header-props="{ sortIcon: null }"
            :item-class="getRowClass"
          >
            <template v-slot:header.checkbox v-if="parcelas.length > 0">
              <div class="row align-center mt-0 mb-0">
                <v-checkbox
                  v-model="selectAll"
                  @click="toggleSelectAll"
                  class="ms-6"
                  hide-details
                ></v-checkbox>
                <span class="mt-5 font-weight-medium">Marcar todos</span>
              </div>
            </template>

            <template v-slot:item.checkbox="{ item: parcela }">
              <v-checkbox
                v-model="boletosSelecionados"
                v-if="
                  !parcela.ehTaxa &&
                  parcela.situacao < 1 &&
                  !parcela.linhaDigitavel &&
                  (!parcela.boleto || parcela.boleto)
                "
                :value="parcela"
                class="ms-3 mt-0"
                hide-details
                @click="showHistorico = false"
              ></v-checkbox>
            </template>

            <template v-slot:item.numero="{ item: parcela }">
              <span class="font-weight-medium">{{ parcela.numero }}</span>
              <v-chip
                v-if="parcela.origemDaCobranca === 'PRE_MATRICULA'"
                x-small
                color="blue lighten-4"
                class="ml-1"
              >
                Pré-matrícula
              </v-chip>
              <span v-if="parcela.descricao" class="d-block caption grey--text text--darken-1">
                {{ parcela.descricao }}
              </span>
            </template>

            <template v-slot:item.referencia="{ item: parcela }">
              <span class="font-weight-medium">
                {{ parcela.referencia_3 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
              </span>
            </template>

            <template v-slot:item.valor="{ item: parcela }">
              <span class="font-weight-medium">{{ parcela.valor | currency }}</span>
            </template>

            <template v-slot:item.valorpago="{ item: parcela }">
              <v-chip
                small
                :color="parcela.valorpago > 0 ? 'green darken-1' : 'grey lighten-1'"
                :class="parcela.valorpago > 0 ? 'white--text' : 'grey--text text--darken-2'"
              >
                {{ parcela.valorpago | currency }}
              </v-chip>
            </template>

            <template v-slot:item.valordesconto="{ item: parcela }">
              <span
                v-if="!parcela.ehTaxa"
                :class="
                  parcela.matricula.desconto_1 > 0
                    ? 'blue--text text--darken-2 font-weight-medium'
                    : ''
                "
              >
                {{ parcela.referencia_1 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }} -
                {{ parcela.matricula.desconto_1 | currency }} <br />
                {{ parcela.referencia_2 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }} -
                {{ parcela.matricula.desconto_2 | currency }} <br />
                {{ parcela.referencia_3 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }} -
                {{ parcela.matricula.desconto_3 | currency }} <br />
              </span>
            </template>

            <!-- <template v-slot:item.valoraberto="{ item: parcela }">
              <v-chip
                small
                :color="calcularValorAberto(parcela) > 0 ? 'orange darken-2' : 'green darken-1'"
                class="white--text font-weight-bold"
              >
                {{ calcularValorAberto(parcela) | currency }}
              </v-chip>
            </template> -->

            <template v-slot:item.situacao="{ item: parcela }">
              <e-situacao-parcela small :parcela="parcela" />
            </template>

            <template v-slot:item.actions="{ item: parcela }">
              <div class="d-flex align-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="green darken-3"
                      dark
                      class="mr-1"
                      v-bind="attrs"
                      v-on="on"
                      :loading="parcela._verificando"
                      @click.stop="verificarSituacao(parcela)"
                    >
                      <v-icon x-small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Verificar Situação</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="parcela.estaPaga || parcela.estaNegociada || !user.caixa"
                      x-small
                      color="info"
                      class="mr-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="() => openModalBaixarParcela(parcela, matriculaSelecionada)"
                    >
                      <v-icon x-small>mdi-arrow-down-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Baixar parcela</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="primary"
                      dark
                      class="mr-1"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="
                        () => [historico(parcela.id), (showHistorico = true), scrollToTop()]
                      "
                    >
                      <v-icon x-small>mdi-list-status</v-icon>
                    </v-btn>
                  </template>
                  <span>Histórico</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :disabled="parcela.estaPaga"
                      x-small
                      color="red darken-1"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="() => openModalDeletar(parcela)"
                    >
                      <v-icon x-small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar</span>
                </v-tooltip>
              </div>
            </template>

            <template #[`body.append`] v-if="parcelas.length > 0">
              <tr class="totais-row">
                <td
                  colspan="3"
                  class="text-right text-caption font-weight-bold grey--text text--darken-2 py-3"
                >
                  TOTAIS
                </td>
                <td class="font-weight-bold py-3">{{ totalValor | currency }}</td>
                <td class="py-3">
                  <v-chip small color="green darken-1" class="white--text font-weight-bold">
                    {{ totalPago | currency }}
                  </v-chip>
                </td>
                <td colspan="2"></td>
              </tr>
            </template>
          </v-data-table>

          <v-sheet v-if="!gerandoParcelas">
            <v-btn
              v-if="temApenasParcelaDaPreMatricula"
              color="primary"
              outlined
              class="ms-3 mb-3"
              @click="gerarMensalidadesRestantes()"
            >
              Gerar mensalidades restantes
            </v-btn>
            <v-btn
              color="primary"
              :disabled="boletosSelecionados.length < 1"
              class="ms-3 mb-3"
              @click="registrarBoletosSelecionados()"
            >
              Registrar boletos selecionados
            </v-btn>
          </v-sheet>
        </v-col>

        <v-dialog v-model="showDialog" persistent max-width="400">
          <v-card>
            <v-card-title class="text-h5"> Caixa fechado </v-card-title>
            <v-card-text>Por favor abra o caixa antes de continuar.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="[(showDialog = false), abrirCaixa()]">
                Abrir Caixa
              </v-btn>
              <v-btn color="green darken-1" text @click="[(showDialog = false)]"> Continuar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="modalDeletarMensalidade" max-width="450">
          <v-card>
            <v-card-title class="text-h5"> Deseja excluir essa mensalidade? </v-card-title>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="modalDeletarMensalidade = false">
                Continuar
              </v-btn>
              <v-btn color="green darken-1" text @click="modalDeletarMensalidade = false">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <NovaParcela
          @matriculasVinculadas="refresh()"
          @status="handleStatus"
          :showNovaParcela="showNovaParcela"
          :matricula="matriculaSelecionada.id"
        />
      </v-row>
    </v-container>

    <Drawer
      :show="showHistorico"
      :parcela="parcela"
      :listaDeParcelas="listaDeParcelas"
      @valorEstornado="loadAgain()"
    />
  </main-template>
</template>
<script>
import { mapGetters } from "vuex";
import searchQuery from "@/plugins/searchQuery";
import Drawer from "@/components/Mensalidades/Drawer.vue";
import NovaParcela from "@/components/Mensalidades/NovaParcela.vue";
import EGerarMensalidades from "@/components/Mensalidades/EGerarMensalidades.vue";

export default {
  name: "MensalidadesPage",
  components: {
    Drawer,
    NovaParcela,
    EGerarMensalidades,
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    totalValor() {
      return this.parcelas.reduce((sum, p) => sum + (p.valor || 0), 0);
    },
    totalPago() {
      return this.parcelas.reduce((sum, p) => sum + (p.valorpago || 0), 0);
    },
    totalDesconto() {
      return this.parcelas.reduce((sum, p) => sum + (p.desconto || 0), 0);
    },
    totalAberto() {
      return this.parcelas.reduce((sum, p) => sum + this.calcularValorAberto(p), 0);
    },
    gerandoParcelas() {
      return Boolean(this.parametroConsulta) && this.parcelasCriadas === false;
    },
  },
  data() {
    return {
      parcelasCriadas: false,
      temApenasParcelaDaPreMatricula: false,
      selectAll: false,
      modalDeletarMensalidade: false,
      estornoMessage: false,
      showDialog: false,
      showNovaParcela: false,
      listaDeParcelas: [],
      parcela: {},
      showHistorico: false,
      matriculaSelecionada: {},
      matriculas: [],
      parcelas: [],
      parcelaSelecionada: {},
      boletosSelecionados: [],
      searchQuery,
      loadingMatriculas: true,
      loadingParcelas: false,
      modalBaixarParcela: { open: false, parcela: null },
      table: {
        headers: [
          { text: "Boleto", value: "checkbox" },
          { text: "Nº", value: "numero" },
          { text: "Referência", value: "referencia" },
          { text: "Valor", value: "valor" },
          { text: "Valor Pago", value: "valorpago" },
          { text: "Valor Desconto", value: "valordesconto" },
          // { text: "Valor Aberto", value: "valoraberto" },
          { text: "Situação", value: "situacao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
      parametroConsulta: null,
    };
  },

  watch: {
    "$route.query.matricula": {
      immediate: true,
      handler(novoValor) {
        this.parametroConsulta = novoValor;
        this.boletosSelecionados = [];
        this.selectAll = false;
      },
    },
  },

  mounted() {
    this.parametroConsulta = this.$route.query.matricula;

    this.loadMatriculas();
    if (!this.user.caixa) {
      this.showDialog = true;
      if (this.parametroConsulta) {
        this.showDialog = false;
      }
    }
  },

  methods: {
    calcularValorAberto(parcela) {
      const diff = parcela.valor - parcela.valorpago - parcela.desconto;
      return Math.abs(diff) < 0.000001 ? 0 : diff;
    },

    getRowClass(parcela) {
      if (parcela.situacao >= 1) return "row-paga";
      return "";
    },

    createParcelas() {},
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.boletosSelecionados = this.parcelas.filter(
          (parcela) => !parcela.ehTaxa && !parcela.boleto && parcela.situacao < 1
        );
      } else {
        this.boletosSelecionados = [];
      }
    },

    // A parcela de matrícula paga na pré-matrícula, sozinha (taxas à parte), ainda pede as
    // mensalidades restantes; qualquer outra parcela já gerada encerra a geração.
    apenasParcelaDaPreMatricula(parcelas) {
      const parcelasSemTaxa = parcelas.filter((parcela) => !parcela.ehTaxa);
      return (
        parcelasSemTaxa.length === 1 && parcelasSemTaxa[0].origemDaCobranca === "PRE_MATRICULA"
      );
    },

    aoGerarParcelas() {
      this.parcelasCriadas = true;
      this.loadParcelas(this.matriculaSelecionada);
    },

    async gerarMensalidadesRestantes() {
      const matricula = this.matriculaSelecionada;
      await this.$router.push({ name: "mensalidades", query: { matricula: matricula.id } });
      await this.verifyParcelas(matricula);
    },

    openModalDeletar(parcela) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja excluir esta parcela?",
        confirmationCode: parcela.id,
        confirmationMessage: `Por favor, digite <strong>${parcela.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Parcela");
              try {
                await this.$services.parcelasService.deletarParcela(parcela.id);
                this.$toast.success("Parcela excluida com sucesso");
                this.$forceUpdate();
                this.refresh();
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.$loaderService.close();
              }
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },

    consultarBoleto(parcela) {
      this.$loaderService.open("Consultanto Boleto");
      // Implementar a pesquisa ao boleto
      this.$services.parcelasService
        .consultarBoleto(parcela)
        .then((response) => {
          // window.open(response.data)
        })
        .catch((err) => {
          this.$handleError(err.error);
        })
        .finally(() => {
          this.$loaderService.close();
        });
    },

    async registrarBoletosSelecionados() {
      let erroOcorreu = false;
      if (this.boletosSelecionados.length > 0) {
        this.$loaderService.open("Aguarde o sistema está registrando o(s) Boleto(s)");
      }

      for (let index = 0; index < this.boletosSelecionados.length; index++) {
        /* eslint-disable no-await-in-loop */
        const boleto = this.boletosSelecionados[index];
        this.$loaderService.open(
          `Registrando o Boleto ${index + 1} de ${this.boletosSelecionados.length}`
        );
        try {
          const res = await this.$services.parcelasService.incluirBoleto(boleto); // igore this line
          if (res.data.erros && res.data.erros.length) {
            this.$handleError({ message: res.data.erros[0].mensagem });
            // console.log(res.data);
            erroOcorreu = true;
            break;
          } else {
            this.$toast.success("Boleto registrado com sucesso!");
          }
        } catch (err) {
          this.$handleError(err);
          // console.log(err);
          erroOcorreu = true;
          break;
        } finally {
          this.$loaderService.close();
        }
        /* eslint-enable no-await-in-loop */
      }
      if (!erroOcorreu) {
        this.refresh();
        this.boletosSelecionados = [];
      }
    },

    handleStatus(event) {
      this.showNovaParcela = event;
    },
    selecionarMatricula(matricula) {
      this.showNovaParcela = false;
      this.showHistorico = false;

      this.matriculaSelecionada = { ...matricula };
      if (matricula.id === this.matriculaSelecionada.id) {
        this.loadParcelas(matricula);
      }
    },

    async getCarneDePagamento(matricula_id, type) {
      this.showHistorico = false;
      this.loadingParcelas = true;
      try {
        const response = await this.$services.matriculasService.getMatricula(matricula_id, type);
      } catch (exception) {
        this.$handleError(exception);
      } finally {
        this.loadingParcelas = false;
      }
    },

    async loadParcelas(matricula) {
      this.boletosSelecionados = [];
      this.loadingParcelas = true;
      this.matriculaSelecionada = {};
      try {
        const matriculaDetalhada = await this.$services.matriculasService.getDetails(matricula.id);

        this.parcelas = await this.$services.matriculasService.parcelas(
          matriculaDetalhada.parcelas
        );
        this.temApenasParcelaDaPreMatricula = this.apenasParcelaDaPreMatricula(this.parcelas);
        this.matriculaSelecionada = { ...matriculaDetalhada };
      } catch (error) {
        this.$handleError(error);
      }
      this.loadingParcelas = false;
    },

    async verifyParcelas(matricula) {
      try {
        this.loadingParcelas = true;
        this.boletosSelecionados = [];
        this.selectAll = false;
        const matriculaDetalhada = await this.$services.matriculasService.getDetails(matricula.id);
        this.matriculaSelecionada = { ...matriculaDetalhada };

        const parcelasResponse = await this.$services.matriculasService.parcelas(
          matriculaDetalhada.parcelas
        );

        this.parcelas = parcelasResponse || [];
        this.temApenasParcelaDaPreMatricula = this.apenasParcelaDaPreMatricula(this.parcelas);
        // Só com a parcela da pré-matrícula a geração continua aberta, para as mensalidades.
        this.parcelasCriadas = this.parcelas.length > 0 && !this.temApenasParcelaDaPreMatricula;
      } catch (error) {
        this.parcelasCriadas = false;
        this.parcelas = [];
        this.boletosSelecionados = [];
        this.selectAll = false;
      } finally {
        this.loadingParcelas = false;
      }
    },

    async loadMatriculas() {
      this.loadingMatriculas = true;
      this.loadingParcelas = true;
      this.boletosSelecionados = [];
      this.selectAll = false;
      try {
        const data = await this.$services.matriculasService.all();
        this.matriculas = data;

        if (this.parametroConsulta) {
          this.showDialog = false;
          const filtro = this.matriculas.filter((mat) => mat.id == this.parametroConsulta);
          this.matriculaSelecionada = filtro[0] || {};

          await this.verifyParcelas(this.matriculaSelecionada);
        }
      } catch (error) {
        this.$handleError(error.message || error.response?.data?.error?.message);
      } finally {
        this.loadingMatriculas = false;
        this.loadingParcelas = false;
      }
    },

    async historico(parcela) {
      this.showNovaParcela = false;
      const response = await this.$services.parcelasService.getHistorico(parcela);
      this.parcela = { ...response.data };
      this.listaDeParcelas = [...response.data.mensalidades];
    },

    openModalBaixarParcela(parcela, matriculaSelecionada) {
      this.parcela = { ...parcela };
      this.$router.push({
        name: "mensalidades.baixar",
        params: { prestacao_id: this.parcela.id, matricula_id: matriculaSelecionada.id },
        query: { matricula: matriculaSelecionada.id },
      });
    },

    openModalNovaParcela() {
      this.showHistorico = false;
      this.showNovaParcela = !this.showNovaParcela;
    },

    refresh() {
      this.estornoMessage = true;
      this.showNovaParcela = false;
      this.showHistorico = false;
      this.loadParcelas(this.matriculaSelecionada);
      this.boletosSelecionados = [];
    },

    loadAgain() {
      this.estornoMessage = true;
      this.showNovaParcela = false;
      this.showHistorico = false;
      this.loadParcelas(this.matriculaSelecionada);
      this.$toast.success("Baixa feita com sucesso!");
    },

    async verificarCaixaAberto() {
      if (!this.user.caixa) {
        this.showDialog = true;
      }
    },

    abrirCaixa() {
      this.$router.push({ name: "caixas" });
    },

    async verificarSituacao(parcela) {
      parcela._verificando = false;
      try {
        parcela._verificando = true;
        const response = await this.$services.parcelasService.verificarSituacaoParcela(parcela);
        this.$toast.success(response.data.message || "Situação verificada com sucesso!");
        this.loadParcelas(this.matriculaSelecionada);
      } catch (error) {
        this.$toast.error("Erro ao verificar situação da parcela.");
      } finally {
        parcela._verificando = false;
      }
    },
  },
};
</script>
<style>
.row-pointer:hover {
  cursor: pointer;
}
.row-paga td {
  background-color: #f1f8e9 !important;
}
.totais-row td {
  border-top: 2px solid #e0e0e0 !important;
  background-color: #fafafa !important;
  font-size: 0.85rem;
}
</style>
